import { IAutoMapper } from "../../../../../core/automapper/interfaces";

export const mapAddressBulkUpdateItem = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AddressBulkUpdate")
    .forMember("projectId", o => o.projectId)
    .forMember("addressIds", o => o.addressIds)
    .forMember("notes", o => o.notes);
};
